/*-------------------------------------------------------------------
グローバル変数
--------------------------------------------------------------------*/
let headerHeight;

/*-------------------------------------------------------------------
関数定義
--------------------------------------------------------------------*/
function isPc() {
  return window.innerWidth >= 768;
}
// Mobileの場合True
function isMobile() {
  return !isPc();
}

/**
 * 指定の要素のテキストを1文字ずつspanで囲む
 */
const wrapSpan = () => {
  const textWrap = document.querySelectorAll('.js-wrapSpan');
  textWrap.forEach((t) => (
    t.innerHTML = t.textContent.replace(/\S/g, '<span>$&</span>')
  ));
}

/**
 * アンカーリンク
*/
function scrollHash() {
  const hash = location.hash;
  if (hash && jQuery(hash).length) {
    const offset = jQuery(hash).offset().top;
    const scrollto = offset - (("fixed" !== jQuery("#header").css("position")) ? (headerHeight + 20) : 0);
    jQuery('html, body').animate({ scrollTop: scrollto }, 500);
  }
}


/*-------------------------------------------------------------------
読み込み時実行
--------------------------------------------------------------------*/
document.addEventListener("DOMContentLoaded", function () {
  headerHeight = document.querySelector('.js-header').offsetHeight;
  // wrapSpan();
  // setTimeout('stopload()', 10000);
});


/*-------------------------------------------------------------------
イベント
--------------------------------------------------------------------*/
/**
 * スクロールバーを除いた画面幅の取得
 */
jQuery(window).on('load resize', function () {
  let vw = document.body.clientWidth;// スクロールバーを除いた幅を取得
  let vh = window.innerHeight; // アドレスバーを覗いた画面高さ
  headerHeight = document.querySelector('.js-header').offsetHeight;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
});

jQuery(function () {
  scrollHash();

  // スクロール判定
  jQuery(window).on("scroll", function () {
    let scrollTop = jQuery(this).scrollTop();
    let windowHeight = jQuery(this).height();
    let documentHeight = jQuery(document).height();

    if (100 < scrollTop) {
      jQuery("body").attr("data-scroll", "true");
    } else {
      jQuery("body").attr("data-scroll", "false");
    }

    if (documentHeight - (windowHeight + scrollTop) <= 0) {
      jQuery("body").attr("data-scroll-bottom", "true");
    } else {
      jQuery("body").attr("data-scroll-bottom", "false");
    }

    /**
     * トップに戻るボタン
     */
    const totop = jQuery('.js-totop');
    const totopTarget = jQuery(`.${totop.data("target")}`);
    if ((totopTarget.length ? totopTarget.innerHeight() : headerHeight) < scrollTop) {
      totop.addClass('is-active');
    } else {
      totop.removeClass('is-active');
    }

  });

  // ハンバーガーメニュー
  jQuery(".js-hamburger").on("click", function () {
    jQuery(this).toggleClass("is-open");
    jQuery(".js-drawer").fadeToggle();
    jQuery(".js-header").toggleClass("is-open");
    // ドロワーメニューを開いているときは、後ろの画面がスクロールしないようにする
    if (jQuery(".js-hamburger").hasClass("is-open")) {
      jQuery("body").css("overflow", "hidden");
    } else {
      jQuery("body").css("overflow", "initial");
    }
  });

  // ドロワーナビのaタグをクリックで閉じる
  jQuery(".js-drawer a[href]").on("click", function () {
    jQuery(".js-hamburger").removeClass("is-open");
    jQuery(".js-header").removeClass("is-open");
    jQuery(".js-drawer").fadeOut();
    jQuery("body").css("overflow", "initial"); // ← 追加
  });

  // resizeイベント
  jQuery(window).on("resize", function () {
    if (window.matchMedia("(min-width: 768px)").matches) {
      jQuery(".js-hamburger").removeClass("is-open");
      jQuery(".js-header").removeClass("is-open");
      jQuery(".js-drawer").fadeOut();
      jQuery("body").css("overflow", "initial"); // ← 追加
    }
  });

  /* ヘッダ */
  jQuery(window).on('load scroll', function () {
    // if (jQuery('body').hasClass('home')) {
    const $header = jQuery('.js-header');
    if ($header.length) {
      const target = jQuery(`.${jQuery($header).data('target')}`);
      const targetHeight = (target.length ? target.innerHeight() : headerHeight * 1.1);
      let position = jQuery(this).scrollTop();
      if (position > targetHeight) {
        $header.addClass('is-fixed');
      } else if (position == 0) {
        $header.removeClass('is-fixed');
      }
    }
    // }
  });

  /* スムーススクロール */
jQuery(document).on('click', 'a[href*="#"]:not(".js-tabIndex, .js-modal, .js-accordion, .toc_toggle a")', function (e) {
  const currentUrl = location.protocol + '//' + location.host + location.pathname; // 現在のURL
  const href = jQuery(this).prop("href");
  const hrefUrl = href.split('#')[0];   // リンク先のURL

  if (currentUrl === hrefUrl) {
      e.preventDefault();

      let id = '#' + href.split('#')[1];  // リンク先のアンカー
      let speed = 500;
      let target = jQuery("#" === id ? "html" : id);

      if (target.length) {
          let header = document.querySelector('.js-header'); // ヘッダー要素
          let headerHeight = header ? header.offsetHeight : 0; // ヘッダーの高さを取得

          // `is-fixed` クラスがある場合のみ高さを考慮する
          if (!header.classList.contains('is-fixed')) {
              headerHeight = 0;
          }

          let position = target.offset().top - headerHeight;
          position = Math.max(position, 0);  // 0より小さくならないように調整

          jQuery("html, body").animate({ scrollTop: position }, speed);
          jQuery(this).blur();
      }
  }
});


  // スライダー
  const $scope = $('.js-slider-scope');

  $scope.each(function () {
      const $this = $(this),
          $thisSlider = $this.find('.js-slider'),
          $thisArrows = $this.find('.js-slider-arrows'), //矢印を出力する要素
          $thisDots = $this.find('.js-slider-dots'); //ドットを出力する要素

      $thisSlider.slick({
          slidesToShow: 2,
          dots: true,
          prevArrow: '<img src="./assets/img/common/slider-arrow-prev.svg" class="slide-arrow p-slider__prev-arrow">',
          nextArrow: '<img src="./assets/img/common/slider-arrow-next.svg" class="slide-arrow p-slider__next-arrow">',
          appendDots: $thisDots, //ドットを指定の場所に出力
          appendArrows: $thisArrows, //矢印を指定の場所に出力
          useTransform: false, //スライドがチラつくため設定
          useCSS: false,
          easing: 'swing',
          pauseOnHover: false,
          pauseOnFocus: false,
          responsive: [
            {
              breakpoint: 768, // 399px以下のサイズに適用
              settings: {
              slidesToShow: 1,
              },
            },
          ],
      });
  });

  /* 電話リンク */
  let $ua = navigator.userAgent;
  if ($ua.indexOf("iPhone") < 0 && $ua.indexOf("Android") < 0) {  // PCのとき
    jQuery('a[href^="tel:"]') // 電話リンク
      .css("cursor", "default") // カーソルをポインターにしない
      .css('pointer-events', 'none')  // ホバーなども動作しない
      .on("click", function (e) {
        e.preventDefault();
      });
  }
});


 /* アコーディオンメニュー　details＋summary */
document.addEventListener("DOMContentLoaded", () => {
  setUpAccordion();
});

/**
 * ライブラリ(GSAP)を使ってアコーディオンのアニメーションを制御します
 */
const setUpAccordion = () => {
  const details = document.querySelectorAll(".js-details");
  const IS_OPENED_CLASS = "is-opened"; // アイコン操作用のクラス名

  details.forEach((element) => {
    const summary = element.querySelector(".js-summary");
    const content = element.querySelector(".js-content");
    const btn = summary.querySelector(".p-faq__question-btn"); // アイコン取得

    summary.addEventListener("click", (event) => {
      // デフォルトの挙動を無効化
      event.preventDefault();

      // is-openedクラスの有無で判定（detailsのopen属性の判定だと、アニメーション完了を待つ必要がありタイミング的に不安定になるため）
      if (element.classList.contains(IS_OPENED_CLASS)) {
        // アコーディオンを閉じるときの処理
        // アイコン操作用クラスを切り替える(クラスを取り除く)
        element.classList.toggle(IS_OPENED_CLASS);
        btn.classList.toggle(IS_OPENED_CLASS); // アイコンのクラスを削除
        // アニメーション実行
        closingAnim(content, element).restart();
      } else {
        // アコーディオンを開くときの処理
        // アイコン操作用クラスを切り替える(クラスを付与)
        element.classList.toggle(IS_OPENED_CLASS);
        btn.classList.toggle(IS_OPENED_CLASS);

        // open属性を付与
        element.setAttribute("open", "true");

        // アニメーション実行
        openingAnim(content).restart();
      }
    });
  });
}

/**
 * アコーディオンを閉じる時のアニメーション
 */
const closingAnim = (content, element) => gsap.to(content, {
  height: 0,
  opacity: 0,
  duration: 0.4,
  ease: "power3.out",
  overwrite: true,
  onComplete: () => {
    // アニメーションの完了後にopen属性を取り除く
    element.removeAttribute("open");
  },
});

/**
 * アコーディオンを開く時のアニメーション
 */
const openingAnim = (content) => gsap.fromTo(
  content,
  {
    height: 0,
    opacity: 0,
  },
  {
    height: "auto",
    opacity: 1,
    duration: 0.4,
    ease: "power3.out",
    overwrite: true,
  });

  /**
   * フロートCTA
   */
  document.addEventListener("DOMContentLoaded", () => {
    const floatCta = document.querySelector(".js-float-cta");
    const contact = document.querySelector("#contact");
    const mediaQuery = window.matchMedia("(max-width: 767px)");
  
    if (!floatCta || !contact) return;
  
    function checkPosition() {
      if (!mediaQuery.matches) {
        // 画面幅が 767px を超えたら .hide を削除して処理を停止
        floatCta.classList.remove("hide");
        return;
      }
  
      const contactTop = contact.getBoundingClientRect().top + window.scrollY;
      const floatCtaTop = floatCta.getBoundingClientRect().top + window.scrollY;
  
      if (floatCtaTop > contactTop) {
        floatCta.classList.add("hide");
      } else {
        floatCta.classList.remove("hide");
      }
    }
  
    // スクロールとリサイズ時に実行
    window.addEventListener("scroll", checkPosition);
    window.addEventListener("resize", checkPosition);
    mediaQuery.addEventListener("change", checkPosition); // 画面幅が変わった時にも実行
  
    // 初回実行
    checkPosition();
  });  
  
// // カードのコンテンツの高さを揃える処理
// function adjustCardHeights() {
//   const cardTitle = document.querySelectorAll('.js-card-title');
//   const cardDetails = document.querySelectorAll('.js-card-details');

//   // 高さを取得する関数
//   function getMaxHeight(elements) {
//     const heights = Array.from(elements).map((el) => el.offsetHeight);
//     return Math.max(...heights);
//   }

//   // min-heightをリセットする関数
//   function resetHeight(elements) {
//     elements.forEach((el) => {
//       el.style.minHeight = 'auto';
//     });
//   }

//   // 最大値をmin-heightに適用する関数
//   function applyMinHeight(elements, height) {
//     elements.forEach((el) => {
//       el.style.minHeight = `${height}px`;
//     });
//   }

//   // 高さリセット
//   resetHeight(cardTitle);
//   resetHeight(cardDetails);

//   // 最大値取得
//   const maxCardTitleHeight = getMaxHeight(cardTitle);
//   const maxCardDetailsHeight = getMaxHeight(cardDetails);

//   // 高さ適用
//   applyMinHeight(cardTitle, maxCardTitleHeight);
//   applyMinHeight(cardDetails, maxCardDetailsHeight);
// }

// // **ページの読み込み時に高さ調整**
// document.addEventListener("DOMContentLoaded", function () {
//   setTimeout(adjustCardHeights, 100);
// });

// // **ウィンドウのリサイズ時にも高さ調整**
// window.addEventListener("resize", function () {
//   setTimeout(adjustCardHeights, 100);
// });

// // **外部から高さ調整を呼び出せるようにする**
// window.recalculateCardHeights = adjustCardHeights;